import { GetIsSiteAdmin } from 'domain/usecases/get-is-site-admin';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetIsSiteAdmin extends BaseHttpService<GetIsSiteAdmin.Model> implements GetIsSiteAdmin {
  async getIsSiteAdmin(params: GetIsSiteAdmin.Params): Promise<GetIsSiteAdmin.Model> {
    return await this.request('get', {}, params);
  }
}
